import React, { FC } from 'react';
import { useIconColor } from '../../../hooks/useIconColor';

interface IconBGProps {
  className?: string;
  color?: string;
}

const IconBackgroundRemoval: FC<IconBGProps> = (props: IconBGProps) => {
  const { className, color } = props;

  const { iconColor } = useIconColor();
  const fillColor = color || iconColor;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path d="M16 24V20H12V16H8V20H12V24H16Z" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 28C5.79086 28 4 26.2091 4 24V8C4 7.86193 4.007 7.72549 4.02065 7.59102C4.22549 5.574 5.92893 4 8 4H24C24.0086 4 24.0173 4.00003 24.0259 4.00008C24.0385 4.00016 24.0512 4.0003 24.0638 4.0005C24.3177 4.00447 24.5658 4.03209 24.8061 4.08127C26.6289 4.45425 28 6.067 28 8V24C28 24.3642 27.9513 24.7171 27.8601 25.0525C27.8601 25.0525 27.8601 25.0525 27.8601 25.0525C27.8562 25.0667 27.8523 25.0809 27.8483 25.095C27.7566 25.4177 27.6255 25.7238 27.4604 26.0077C27.4474 26.03 27.4343 26.0521 27.4209 26.0741C27.2564 26.3448 27.0607 26.5944 26.8388 26.818C26.8388 26.818 26.8388 26.818 26.8388 26.818L26.8377 26.8192C26.8315 26.8253 26.8253 26.8315 26.8192 26.8377L26.818 26.8388C26.7307 26.9255 26.6394 27.0082 26.5444 27.0866C25.8529 27.6572 24.9665 28 24 28H8ZM8.80762 6L26 23.1924L26 8C26 6.89975 25.1115 6.007 24.0129 6.00004C24.0086 6.00001 24.0043 6 24 6H8.80762ZM24 26V24.0208L23.9792 24H20V20.0208L19.9792 20H16V16.0208L15.9792 16H12V12.0208L11.9792 12H8V8.0208L7.9792 8L6 8V12H8V16H6V20H8V24H6C6 25.1046 6.89543 26 8 26L8 24H12V26H16V24H20V26H24Z"
        fill="#454545"
      />
    </svg>
  );
};
export default IconBackgroundRemoval;
